// Mock data for CLEDICI Conciergerie Landing Page

export const heroData = {
  title: "VOTRE BIEN MÉRITE UN PILOTAGE D'EXCEPTION",
  subtitle: "Conciergerie locale haut de gamme pour locations courte durée",
  description: "Une équipe terrain, une méthode structurée, un ancrage local. Nous gérons votre bien comme si c'était le nôtre.",
  cta: "Demander un diagnostic gratuit",
  image: "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/9g0okrmq_Redo_this_photo_202601251559.jpeg"
};

export const problemData = {
  tagline: "LE CONSTAT",
  title: "Vous n'avez pas investi pour gérer des problèmes.",
  problems: [
    "Des voyageurs qui annulent à la dernière minute",
    "Un ménage bâclé qui génère des avis négatifs",
    "Des urgences à gérer alors que vous êtes à 500km",
    "Une rentabilité qui stagne sans explication claire"
  ],
  conclusion: "Nous comprenons. C'est précisément pour cela que nous existons."
};

export const methodData = {
  tagline: "NOTRE MÉTHODE",
  title: "Un cadre structuré, pas une prestation vague.",
  steps: [
    {
      number: "01",
      title: "Diagnostic complet",
      description: "Analyse de votre bien, de son potentiel et de vos objectifs. Nous ne promettons pas, nous évaluons."
    },
    {
      number: "02",
      title: "Optimisation listing",
      description: "Photos professionnelles, description optimisée, tarification dynamique. Votre bien mérite d'être vu."
    },
    {
      number: "03",
      title: "Gestion opérationnelle",
      description: "Check-in, ménage, linge, maintenance. Une équipe locale réactive, 7j/7."
    },
    {
      number: "04",
      title: "Reporting transparent",
      description: "Chaque mois, un bilan clair. Revenus, taux d'occupation, axes d'amélioration."
    }
  ]
};

export const protectionData = {
  tagline: "PROTECTION",
  title: "Votre bien est un actif. Nous le traitons comme tel.",
  description: "Avant de vendre des nuitées, nous protégeons votre investissement. Vérification des voyageurs, caution sécurisée, assurance dégradations, état des lieux rigoureux.",
  features: [
    "Vérification d'identité systématique",
    "Caution sécurisée avant chaque séjour",
    "Assurance dégradations incluse",
    "État des lieux photo avant/après"
  ],
  image: "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/vnsg4nlq_These_people_are_202601251555.jpeg"
};

export const targetData = {
  tagline: "POUR QUI ?",
  title: "Nous ne travaillons pas avec tout le monde.",
  forYou: {
    title: "C'est pour vous si",
    items: [
      "Vous possédez un bien de qualité",
      "Vous cherchez un partenaire, pas un prestataire",
      "Vous valorisez la transparence et le professionnalisme",
      "Vous avez une vision long terme"
    ]
  },
  notForYou: {
    title: "Ce n'est pas pour vous si",
    items: [
      "Vous cherchez le moins cher à tout prix",
      "Vous voulez tout contrôler à distance",
      "Vous n'êtes pas prêt à faire confiance",
      "Vous attendez des miracles sans investir"
    ]
  }
};

export const teamData = {
  tagline: "L'ÉQUIPE",
  title: "Des visages, pas une plateforme.",
  description: "Nous sommes une équipe locale, ancrée sur le terrain. Chaque membre connaît vos biens, vos voyageurs, votre quartier.",
  members: [
    {
      name: "Claire",
      role: "Fondatrice & Directrice",
      image: "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/l73tfek1_A_34yearold_french_202601251546.jpeg"
    },
    {
      name: "L'équipe bureau",
      role: "Gestion & Coordination",
      image: "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/9g0okrmq_Redo_this_photo_202601251559.jpeg"
    },
    {
      name: "L'équipe terrain",
      role: "Check-in, ménage, maintenance",
      image: "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/vnsg4nlq_These_people_are_202601251555.jpeg"
    }
  ],
  officeImage: "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/9g0okrmq_Redo_this_photo_202601251559.jpeg"
};

export const ctaData = {
  tagline: "PRÊT À COMMENCER ?",
  title: "Demandez votre diagnostic gratuit.",
  description: "Un échange de 20 minutes pour évaluer votre bien et répondre à vos questions. Sans engagement, sans blabla commercial.",
  formFields: [
    { name: "name", label: "Votre nom", type: "text", placeholder: "Jean Dupont" },
    { name: "email", label: "Email", type: "email", placeholder: "jean@exemple.com" },
    { name: "phone", label: "Téléphone", type: "tel", placeholder: "06 12 34 56 78" },
    { name: "propertyType", label: "Type de bien", type: "select", options: ["Appartement", "Maison", "Studio", "Autre"] },
    { name: "city", label: "Ville du bien", type: "text", placeholder: "Paris, Lyon, Bordeaux..." }
  ],
  cta: "Demander mon diagnostic"
};

export const logoUrl = "https://customer-assets.emergentagent.com/job_55b96808-67ff-4601-9659-d62802a3da85/artifacts/ttkhbolv_Copie%20de%20Quintessence%2824%29.png";

export const navLinks = [
  { label: "Méthode", href: "#methode" },
  { label: "Protection", href: "#protection" },
  { label: "Équipe", href: "#equipe" },
  { label: "Contact", href: "#contact" }
];
